import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card } from '@/shared/components/ui/Card';
import type { MorningSummaryQuickStats } from '../types';

interface EmptyStateProps {
  stats?: MorningSummaryQuickStats;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ stats }) => {
  return (
    <Card className="py-12">
      <div className="flex flex-col items-center justify-center text-center">
        {/* Success icon with glow effect */}
        <div className="relative">
          <div className="absolute inset-0 bg-emerald-500/20 rounded-full blur-xl animate-pulse" />
          <div className="relative p-6 bg-emerald-50 rounded-full border border-emerald-200/50">
            <CheckCircle2 className="h-16 w-16 text-emerald-500" />
          </div>
        </div>

        {/* Message */}
        <h3 className="mt-6 text-2xl font-bold text-gray-900">All Ponds Healthy!</h3>
        <p className="mt-2 text-gray-600 max-w-sm">
          No issues detected in the last 24 hours. Your farm is running smoothly.
        </p>

        {/* Quick stats summary */}
        {stats && (
          <div className="mt-6 flex items-center gap-6 text-sm">
            <div className="text-center">
              <p className="font-semibold text-gray-900">{stats.activePondCount}</p>
              <p className="text-gray-500">Active Ponds</p>
            </div>
            <div className="h-8 w-px bg-gray-200" />
            <div className="text-center">
              <p className="font-semibold text-gray-900">{stats.pondsCheckedToday}</p>
              <p className="text-gray-500">Checked Today</p>
            </div>
            <div className="h-8 w-px bg-gray-200" />
            <div className="text-center">
              <p className="font-semibold text-emerald-600">0</p>
              <p className="text-gray-500">Alerts</p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};
